<template>
  <div>
    <div class="title-main">
      <h1>{{ $t("messages.services") }}</h1>
    </div>
    <div class="subcontainer">
      <div class="p-grid">
        <div class="p-md-6 minicontainer">
          <h2>{{ $t("messages.reserveRooms") }}</h2>
          <p>
            {{ $t("messages.reserveRoomsText") }}
          </p>
          <div style="display: flex; flex-direction: column; align-items: center">
            <div class="boton-enlace">
              <a target="blank" href="/assets/files/documentos_inscripcion.pdf">{{ $t("messages.documentInstructions") }}</a>
            </div>
            <img src="@/assets/layout/images/cirugia.png" alt="" class="image-cirugia" />
          </div>
        </div>

        <div class="p-md-6 minicontainer">
          <h2>{{ $t("messages.accessibility") }}</h2>
          <p>
            {{ $t("messages.accessibilityDescriptionLine1") }}
          </p>
          <p>
            {{ $t("messages.accessibilityDescriptionLine2") }}
          </p>
          <div class="p-mt-6" v-for="item in items" :key="item.title">
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
          </div>           
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'Servicios - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Servicios - QualityCare',
        content: 'Se muestran las Servicios de QualityCare, el centro de cirugía plástica que le brinda la mejor experiencia medico - paciente.',
      },
    ],
  },
  name: "ServicesMain",
  computed: {
    items() {
      const translations = {
        es: [
          {
            title: "301 – ANESTESIA",
            description: "Número Único del Distintivo de Habilitación de Servicios: DHS1165230"
          },
          {
            title: "209 – CIRUGÍA OTORRINOLARINGOLOGÍA",
            description: "Número Único del Distintivo de Habilitación de Servicios: DHS1165228"
          },
          {
            title: "714 – SERVICIO FARMACÉUTICO",
            description: "Número Único del Distintivo de Habilitación de Servicios: DHS1165231"
          },
          {
            title: "217 – OTRAS CIRUGÍAS",
            description: "Número Único del Distintivo de Habilitación de Servicios: DHS1165229"
          },
          {
            title: "213 – CIRUGÍA PLÁSTICA Y ESTÉTICA",
            description: "Número Único del Distintivo de Habilitación de Servicios: DHSS0130052"
          }
        ],
        en: [
          {
            title: "301 – ANESTHESIA",
            description: "Unique Number of the Service Habilitation Badge: DHS1165230"
          },
          {
            title: "209 – OTORHINOLARYNGOLOGY SURGERY",
            description: "Unique Number of the Service Habilitation Badge: DHS1165228"
          },
          {
            title: "714 – PHARMACEUTICAL SERVICE",
            description: "Unique Number of the Service Habilitation Badge: DHS1165231"
          },
          {
            title: "217 – OTHER SURGERIES",
            description: "Unique Number of the Service Habilitation Badge: DHS1165229"
          },
          {
            title: "213 – PLASTIC AND AESTHETIC SURGERY",
            description: "Unique Number of the Service Habilitation Badge: DHSS0130052"
          }
        ],
        fr: [
          {
            title: "301 – ANESTHÉSIE",
            description: "Numéro Unique du Badge d'Habilitation de Service: DHS1165230"
          },
          {
            title: "209 – CHIRURGIE OTORHINOLARYNGOLOGIQUE",
            description: "Numéro Unique du Badge d'Habilitation de Service: DHS1165228"
          },
          {
            title: "714 – SERVICE PHARMACEUTIQUE",
            description: "Numéro Unique du Badge d'Habilitation de Service: DHS1165231"
          },
          {
            title: "217 – AUTRES CHIRURGIES",
            description: "Numéro Unique du Badge d'Habilitation de Service: DHS1165229"
          },
          {
            title: "213 – CHIRURGIE PLASTIQUE ET ESTHÉTIQUE",
            description: "Numéro Unique du Badge d'Habilitation de Service: DHSS0130052"
          }
        ]
      };
      const locale = this.$i18n.locale;
      return translations[locale];
    }
  },
};
</script>

<style lang="scss" scoped>
.subcontainer {
  width: 100%;
  padding: 0px 300px;
  background-color: #ffffff;

  .minicontainer {
    padding: 50px 20px;
    align-items: center;
    justify-content: center;
  }

  .image-container {
    text-align: center;
  }
}

.image-cirugia {
  height: 400px;
}

h1 {
  text-align: center;
  padding: 35px 0px;
  background-color: #063165;
  color: white;
  font-size: 50px;
  user-select: none;
  margin: 0px;
}

h2 {
  text-align: center;
  padding: 20px 0px;
  color: #083078;
  font-weight: bold;
  font-size: 40px;
  user-select: none;
}

p {
  text-align: justify;
  font-size: 17px;
  user-select: none;
}

.boton-enlace {
  text-align: center;
  background-color: #083078;
  padding: 10px 0px;
  color: white;
  user-select: none;
  width: fit-content;
  height: fit-content;
  border-radius: 3px;
  margin-top: 40px;
  transition: 0.5s all;

  a {
    color: white;
    font-size: 16px;
    width: 100%;
    padding: 10px 20px;
  }
}

.boton-enlace:hover {
  background-color: #2B86D9;
}

h3 {
  font-size: 17px;
  font-weight: bold;
}

hr {
  border: none;
  border-left: 1px solid hsla(200, 10%, 50%, 100);
  height: 100vh;
  width: 1px;
}

@media screen and (max-width:1470px) {
  .subcontainer {
    padding: 0px 10px;

    .minicontainer {
      padding: 30px 20px;
    }
  }
}

@media screen and (max-width:470px) {
  .image-cirugia {
    width: 100%;
    height: auto;
  }

  h1 {
    padding: 20px 0px;
    font-size: 35px;
  }
}
</style>
